import { Box, Card, Grid, makeStyles, Typography } from "@material-ui/core";
import { t2 } from "../Locale";
import {
  compute4dTotalEach,
  dateFormat,
  permuteCount,
} from "../utils/functions";
import Bg2 from "../assets/image/4d.png";
import { useDispatch, useSelector } from "react-redux";
import Global from "../assets/css/style";
import { computeRemove } from "../redux/items/FourDCompute";
import DeleteIcon from "@material-ui/icons/Delete";
import { Else, If, Then } from "react-if";
import React from "react";

const useStyles = makeStyles((theme) => ({
  card: {
    height: "100%",
    width: "100%",
    position: "absolute",
    backgroundImage: `url(${
      process.env.REACT_APP_YES_APP === undefined
        ? Bg2
        : process.env.REACT_APP_ASSETS3 + "4d.png?d=xxxxxxx"
    })`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    opacity: 1,
    zIndex: -1,
  },
}));

const Card4d = ({ canDelete = false }) => {
  const classes = useStyles();
  const language = useSelector((state) => state.Language);
  const dispatch = useDispatch();

  const fourDCompute = useSelector((state) => state.fourDCompute);
  const set = useSelector((state) => state.drawSet.set);
  const FourD1Draw = useSelector((state) => state.drawSet.FourD1Draw);

  return fourDCompute.map((e, i) => {
    let f = e.placeBet;
    return (
      <Card
        style={{
          position: "relative",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.45)",
          borderRadius: 21,
          border: "0.5px solid #C4C4C4",
          marginTop: 16,
          zIndex: 0,
        }}
        key={i}
      >
        <Box className={classes.card} />
        <Grid container direction="column" style={{ padding: 16 }}>
          <Grid item container style={{ padding: 12 }}>
            <Grid item container>
              <Typography
                variant="h5"
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  width: "100%",
                }}
              >
                {t2(f.betType, language)}
              </Typography>
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: "thin",
                  marginBottom: 10,
                }}
                variant="subtitle2"
              >
                {f.board.length} {t2("Board", language)}
              </Typography>
            </Grid>
            <Grid item container>
              <Grid item xs={9}>
                <Typography>
                  <b>{t2("Draw Date", language)}: </b>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography>
                  <b>{t2("Draw No.", language)} </b>
                </Typography>
              </Grid>
            </Grid>

            <If condition={"6 Draws" === f.drawWeeks[0]}>
              <Then>
                {FourD1Draw.map((eachFourD1Draw, eachFourD1DrawCtr) => {
                  return (
                    <Grid item container key={eachFourD1DrawCtr}>
                      <Grid item xs={9}>
                        <Typography>
                          {dateFormat(
                            "D, d M Y, g:ia",
                            eachFourD1Draw.date + " 18:30:00"
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography>{eachFourD1Draw.draw_no}</Typography>
                      </Grid>
                    </Grid>
                  );
                })}
              </Then>
              <Else>
                {f.drawWeeks.map((weekName, weekCtr) => {
                  let index = -1;
                  FourD1Draw.forEach((eachFourD1Draw, eachFourD1DrawCtr) => {
                    if (eachFourD1Draw.week.indexOf(weekName) > -1 && index < 0)
                      index = eachFourD1DrawCtr;
                  });

                  if (index < 0) return null;

                  let drawDate = dateFormat(
                    "D, d M Y, g:ia",
                    FourD1Draw[index].date + " 18:30:00"
                  );
                  let drawNo = FourD1Draw[index].no;

                  return (
                    <Grid item container key={weekCtr}>
                      <Grid item xs={9}>
                        <Typography>{drawDate}</Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography>{drawNo}</Typography>
                      </Grid>
                    </Grid>
                  );
                })}
              </Else>
            </If>
          </Grid>
          <Card
            style={{
              backgroundColor: "#F7F7F7",
              position: "relative",
              borderRadius: 16,
              marginTop: 10,
            }}
          >
            <Grid
              container
              style={{
                backgroundColor: Global.color,
                opacity: 1,
                color: "#fff",
              }}
            >
              <Grid item xs={6}></Grid>
              <Grid item xs={3}>
                <Typography
                  variant="subtitle1"
                  style={{
                    fontSize: 12,
                    padding: 10,
                    textTransform: "uppercase",
                  }}
                >
                  {t2("Big", language)}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  variant="subtitle1"
                  style={{
                    fontSize: 12,
                    padding: 10,
                    textTransform: "uppercase",
                  }}
                >
                  {t2("Small", language)}
                </Typography>
              </Grid>
            </Grid>

            <div className="number-container">
              {f.board.map((g, j) => {
                return (
                  <Grid container className="per-number" key={j}>
                    <Grid
                      item
                      xs={6}
                      container
                      style={{ flexDirection: "column" }}
                    >
                      <Grid item>
                        <Typography
                          style={{
                            color: Global.color,
                            padding: 10,
                            fontWeight: "bold",
                            paddingLeft: 30,
                          }}
                        >
                          {f.betType === "4D Roll"
                            ? g.betSlip.map((a) => (a === "" ? "R" : a))
                            : g.betSlip.join("")}
                        </Typography>
                      </Grid>
                      {f.betType === "System Entry" || f.betType === "iBet" ? (
                        <Grid item>
                          <Typography
                            style={{
                              color: Global.color,
                              fontSize: 14,
                              marginTop: -12,
                              paddingLeft: 28,
                            }}
                          >
                            {permuteCount(g.betSlip)} Permutations
                          </Typography>
                        </Grid>
                      ) : null}
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        style={{
                          color: "#6D6D6D",
                          padding: 10,
                          fontWeight: "bold",
                        }}
                      >
                        {g.big}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        style={{
                          color: "#6D6D6D",
                          padding: 10,
                          fontWeight: "bold",
                        }}
                      >
                        {g.small}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}
            </div>
          </Card>

          <Grid item container style={{ marginTop: 0 }}>
            <Grid
              item
              container
              xs={6}
              style={{
                alignItems: "center",
                position: "relative",
                zIndex: 1,
              }}
            >
              {canDelete && (
                <span
                  style={{
                    cursor: "pointer",
                    color: "red",
                  }}
                  onClick={() => {
                    dispatch(computeRemove(i));
                  }}
                >
                  <DeleteIcon
                    style={{
                      fontSize: 32,
                      color: Global.defaultColor,
                    }}
                  />
                </span>
              )}
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={3} style={{ paddingTop: 10 }}>
              <Typography>{t2("Sub Total", language)} </Typography>
              <Typography variant="h6" style={{ fontWeight: "bold" }}>
                {compute4dTotalEach(e, set)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    );
  });
};

export default React.memo(Card4d);
